// Google Analytics 4 helper.
// Reads REACT_APP_GA_MEASUREMENT_ID from env. If not set, all calls are no-ops.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

export const initAnalytics = () => {
  if (initialized || !GA_ID || typeof window === "undefined") return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: true });
};

export const trackPageView = (path) => {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) {
    if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.info("[analytics] event (no GA)", name, params);
    }
    return;
  }
  window.gtag("event", name, params);
};

export const GA_ENABLED = Boolean(GA_ID);
